var exports = {
  "xw": "xf0b3b88a--644bfb--review_container",
  "nb": "xf0b3b88a--644bfb--review--refused",
  "jC": "xf0b3b88a--644bfb--show-more-reviews-button-container",
};

module.exports = exports;
